import { render, staticRenderFns } from "./QuestionReplyModal.vue?vue&type=template&id=a58fbcfe&scoped=true&"
import script from "./QuestionReplyModal.vue?vue&type=script&lang=js&"
export * from "./QuestionReplyModal.vue?vue&type=script&lang=js&"
import style0 from "./QuestionReplyModal.vue?vue&type=style&index=0&id=a58fbcfe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a58fbcfe",
  null
  
)

export default component.exports